import { Injectable } from '@angular/core';
import { Login } from '../../models/login.interface';
import { StorageService } from '../utility/storage/storage.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginInput } from '../../models/loginInput.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import {UrlControllerService} from '../url-controller.service';
import {IAppState} from '../../store/state/app.state';
import {Store} from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService extends UrlControllerService {
  /**
   * Barra loading componente login
   */
  loading = false;

  /**
   * Utente loggato
   */
  user: Login;

  /**
   * Costruttore se utente presente nel localstorage inizializzo
   * @param http Per le chiamate al servizio
   * @param storageService Per salvare e recuperare dati
   * @param router Per navigare tra le pagine
   * @param snackBar Per visualizzare messaggi
   */
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private router: Router,
    public snackBar: MatSnackBar,
    public _store: Store<IAppState>
  ) {
    super(_store);
    const user: Login = this.storageService.getStoredObject('currentUser');
    if (user) {
      this.user = user;
    }
  }

  /**
   * Login utente
   * @param user Utente da autenticare
   */
  login(utente: LoginInput, returnUrl: string) {
    const md5Password = CryptoJS.MD5(utente.Password);
    this.http
      .get(
        `https://fe-proxyhts-mst.mstchannel.com/rest/locale/languages/${utente.Username}/${md5Password}`
      )
      .subscribe((data: any) => {
        if (data && data.languages && data.languages.length > 0) {
          this.user = {
            Username: utente.Username,
            Token: md5Password.toString(),
          };
          this.loading = false;

          this.storageService.storeObject('currentUser', this.user);
          if (returnUrl !== '/') {
            this.router.navigate([returnUrl], {
              queryParamsHandling: 'preserve',
            });
          } else {
            this.router.navigate(['pages/index'], {
              queryParamsHandling: 'preserve',
            });
          }
        } else {
          this.loading = false;
          this.snackBar.open('Ops! There was an error authenticating the sender account', '', {
            duration: 4000,
          });
        }
      });
  }

  /**
   * Login utente
   * @param user Utente da autenticare
   */
  loginVideo(utente: LoginInput) {
    const md5Password = CryptoJS.MD5(utente.Password);
    if (
      utente.Username === 'userweb' &&
      md5Password.toString() === 'a747a22aaa89a73b34adb69148fc2fe7'
    ) {
      this.user = {
        Username: utente.Username,
        Token: md5Password.toString(),
      };
      this.loading = false;

      this.storageService.storeObject('currentUserVideo', this.user);
      this.router.navigate(['/extra/video'], { queryParamsHandling: 'preserve' });
    } else {
      this.loading = false;
      this.snackBar.open('Ops! There was an error authenticating the sender account', '', {
        duration: 4000,
      });
    }
  }

  /**
   * Rimuove l'utente dal local storage per effettuare il logout
   */
  logout(): void {
    window.localStorage.removeItem('currentUser');
    this.router.navigate(['/extra/login'], { queryParamsHandling: 'preserve' });
  }

  /**
   * Rimuove l'utente dal local storage per effettuare il logout
   */
  logoutVideo(): void {
    window.localStorage.removeItem('currentUserVideo');
    this.router.navigate(['/extra/video/login'], { queryParamsHandling: 'preserve' });
  }
}
